import axios from "axios";
import { devLog, devError } from "../utils/devLog";

export const subscribeToBrevo = async ({
  email,
  firstName,
  userType = "candidat",
  company,
}) => {
  try {
    const isDevelopment = process.env.NODE_ENV === "development";
    const isLocalServer =
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1";

    let apiUrl;
    if (isDevelopment && isLocalServer) {
      apiUrl = "http://localhost:3002/api/subscribe";
    } else {
      apiUrl = "/api/subscribe";
    }

    devLog(`🌐 Appel API vers: ${apiUrl}`);

    const response = await axios.post(apiUrl, {
      email,
      firstName,
      userType,
      company,
    });

    devLog("✅ Réponse API:", response.data);
    return response.data;
  } catch (error) {
    devError("❌ Erreur côté client :", error.response?.data || error.message);
    devError("🔍 Status code:", error.response?.status);
    devError("🔍 URL appelée:", error.config?.url);
    throw error;
  }
};
